import React from 'react'
import t from '../../translations/i18n'

export default function Index() {
  return (
    <>
      <section id="hero" className="d-flex align-items-center">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center">
              <h1>{t('sections.init_title')}</h1>
              <h2>{t('sections.init_subtitle')}</h2>
            </div>
            <div className="col-lg-6 order-1 order-lg-2 hero-img">
              <img
                src={t('sections.init_img')}
                className="img-fluid animated"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
